import style from './Form.module.scss';

interface FormAlertProps {
  message?: string;
  type?: 'success' | 'error';
}

const FormAlert = ({ message, type }: FormAlertProps) => {
  return (
    <div>
      {message && (
        <div
          className={`${style.form__alert} ${
            type === 'success' ? style.form__alert__success : style.form__alert__error
          }`}
        >
          <p>{message}</p>
        </div>
      )}
    </div>
  );
};

export default FormAlert;
